import axios from '@/axios'
import sha256 from 'crypto-js/sha256'

async function uploadFiles(files, prefix, fileName = null) {
	if (!files || files.length < 1) return []
	const formData = new FormData()
	const newNames = []
	for (const file of files) {
		const newFile = await transformFile(file, fileName)
		newNames.push(newFile.name)
		formData.append('files', newFile)
	}
	if (prefix) formData.append('prefix', prefix)
	await axios.post('/assets/upload', formData)
	return newNames
}

async function transformFile(file, fileName = null) {
	const fileExtension = file.name.split('.').slice(-1)[0]
	const arrayBuffer = await file.arrayBuffer()
	const hash = sha256(await toBase64(file))
	const blob = new Blob([arrayBuffer], { type: file.type })
	if (fileName) {
		return new File([blob], fileName, { type: file.type })
	}
	const hashedfileName = fileExtension ? `${hash}.${fileExtension}` : hash
	return new File([blob], hashedfileName, { type: file.type })
}

function toBase64(file) {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.readAsDataURL(file)
		reader.onload = () => resolve(reader.result)
		reader.onerror = error => reject(error)
	})
}

export default uploadFiles
